/**
 * Geçen süre, en büyük tam birimle (#158): ≥1 gün "gündür", <1 gün "saattir",
 * <1 saat "dakikadır" (en az 1). Önceden gün yuvarlanıyor, 24 saatten kısa
 * sürede "0 gündür bağlı değil" yazıyordu. Okkalı Kurumsal Makineler ekranı
 * aynı kuralı kullanır (utils/elapsed.ts).
 *
 * @param {string|Date|null|undefined} date
 * @param {number} [now] test için
 * @returns {{value:number, unit:"gündür"|"saattir"|"dakikadır"}|null}
 */
export function getElapsed(date, now = Date.now()) {
  if (!date) return null;
  const ms = Math.max(0, now - new Date(date).getTime());
  const days = Math.floor(ms / 86400000);
  if (days >= 1) return { value: days, unit: "gündür" };
  const hours = Math.floor(ms / 3600000);
  if (hours >= 1) return { value: hours, unit: "saattir" };
  return { value: Math.max(1, Math.floor(ms / 60000)), unit: "dakikadır" };
}

/** "5 saattir" gibi; tarih yoksa null */
export function formatElapsed(date, now = Date.now()) {
  const e = getElapsed(date, now);
  return e ? `${e.value} ${e.unit}` : null;
}
